import initialState from 'SRC/modules/redux/initialState'
import actionTypes from 'SRC/modules/redux/actionTypes'

export const scheduleTechnicalInspectionReducer = (state = initialState.scheduleTechnicalInspection, action) => {
  switch (action.type) {
    case actionTypes.SET_TECHNICAL_INSPECTION_FORM_DATA:
      return { ...state, formData: action.payload }
    case actionTypes.SET_SUBMIT_TECHNICAL_INSPECTION_FORM_DATA:
      return { ...state, submitFormData: action.payload }
    case actionTypes.SET_STATION_DETAILS_DATA:
      return { ...state, stationDetailsData: action.payload }
    case actionTypes.SET_TECHNICAL_INSPECTION_RESERVATION_CONFIRMATION:
      return { ...state, reservationConfirmation: action.payload }
    case actionTypes.SET_TECHNICAL_INSPECTION_LOADING:
      return { ...state, isLoading: action.payload }
    case actionTypes.SET_TECHNICAL_INSPECTION_ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}
